<template>
  <vue-scroll :ops="ops" ref="vs" @handle-scroll="handleScroll">
    <div class="markCon">
      <first-Component  class="header" :class="{active:!isShowNav}"  style="position: absolute;top:0;z-index: 999;background-color: white;" :num=5 ></first-Component>

      <first-Component class="animated bounceInDown" style="position: fixed;
    z-index: 999999;
    background-color: white;animation-duration:3s;" :num=5 v-if="!isShowNav"></first-Component>
      <div class="banner animated zoomIn" id="d1">
            <div class="text">
              <span>{{$t('home[3]')}}</span>
            </div>
            <img   style="width:100%;height:100%;cursor: pointer;display: block"   src="../assets/markBanner.jpg">
            <div class="threeBtn">
              <span :style="select2===0?oneStyle:''"  @click="showCon(0)">{{$t('mkList[0]')}}</span>
              <span :style="select2===1?oneStyle:''"  @click="showCon(1)">{{$t('mkList[1]')}}</span>
              <span :style="select2===2?oneStyle:''"  @click="showCon(2)">{{$t('mkList[2]')}}</span>
            </div>

      </div>
      <div class="rd animated zoomInRight" v-if="select2===0" style="text-align: center">
        <div class="title">
          <p>{{$t('mkList[0]')}}</p>
          <div class="three">
            <span style="left: 0"></span>
            <img src="../assets/d.png" alt="">
            <span style="right: 0;"></span>
          </div>

        </div>
        <map-Component class="mapA"></map-Component>
        <img src="../assets/mapm.png" alt="" class="mapB">
        <p class="content">{{$t('Mark.con1')}}</p>
         <p class="content conT">{{$t('Mark.con2')}}</p>
      </div>
      <div class="eq animated zoomIn" v-else-if="select2===1">
        <div class="title">
          <p>{{$t('mkList[1]')}}</p>
          <div class="three">
            <span style="left: 0"></span>
            <img src="../assets/d.png" alt="">
            <span style="right: 0;"></span>
          </div>
        </div>
        <div class="item itemOne" v-for="(item,index) in caseList" :key="index">
          <span>
            <img src="../assets/p.png" alt="">
          </span>
          <p>{{item}}</p>
        </div>
      </div>
      <div class="qu animated fadeInLeft" v-else>
        <div class="title">
          <p>{{$t('mkList[2]')}}</p>
          <div class="three">
            <span style="left: 0"></span>
            <img src="../assets/d.png" alt="">
            <span style="right: 0;"></span>
          </div>
        </div>
        <div class="a">
          <div class="item" v-for="(item,index) in newsList" :style="index%2==1?itemStyle:''" :key="index" @click="gotoNews(item.ID)">
             <div class="left">
               <span>{{item.a}}</span>
               <span>{{item.month}}</span>
             </div>
            <span class="hr"></span>
            <div class="right">
              <span>{{item.TITLE}}</span>
              <span>{{item.ZY}}</span>
            </div>
          </div>
        </div>
      </div>
      <foot-Component @gotoTop="gotoTop"></foot-Component>
    </div>
  </vue-scroll>
</template>

<script>
  import firstComponent from './first'
  import footComponent from './foot'
  import mapComponent from './map'
  import {getNewsUrl} from '../util/lang'
    export default {
        name: "marka",
      data(){
          return{
            caseList:[
              '"I am a parts counter salesman and would just like to say that I have sold hundreds, if not thousands, of BY MOTOR brand products and have yet to have any customer return to my location with any problems. I also use TRICO brand products on my personal truck and will continue to as long as they are available to me. Thanks again."   – Thomas T. (New Market, AL)',
              'I want to let you know how pleased I was with the packaging of the motor I bought. I was able to open the package without any trouble and install  in no time at all." Consumer – Arnold F. (Vallejo, CA)',
              '“BY MOTOR do a great job and are affordably priced.  I will continue to use your products. Again, thanks.”Consumer – Barry Eck (New Jersey)',
              '“I made some mistake while installing so I contacted BY MOTOR. Thank you, what a great response. You can count on the brand I will use and I will let all my friends and family know about the customer service. They did the trick and fit like a glove.”Consumer – John G.',
              '“ I love your products and appreciated your fast reply. Great service, BY MOTOR. Secured me as a return customer!” Consumer – Adam D. (Springfield, MA)'
            ],
            itemStyle:{marginLeft:'4%'},
            newsList:[],
            isShowNav:true,
            ops: {
              vuescroll: {
                mode: 'native',
                sizeStrategy: 'percent',
                detectResize: true
              },
              scrollPanel: {
                speed: 300,
                scrollingX: false,
              },
              rail: {
                background: '#01a99a',
                opacity: 0,
                size:'2px'
              },
              bar: {
                showDelay: 500,
                background: '#0C3665',
                size: '2px',
              }
            },
            select2:0,
            oneStyle:{
              backgroundColor:' #0C3665',
              color:'white'
            }
          }
      },
      components:{firstComponent,footComponent,mapComponent},
      mounted(){
        if(this.$route.query.select!=undefined){
          this.select=this.$route.query.select
          this.select2=this.$route.query.select
        }else{
          console.log("路由跳转参数为空")
        }
        if(this.$i18n.locale==='en'){
          this.getPro('8')
        }else{
          this.getPro('10')
        }
      },
      methods:{
        gotoTop(){
          this.$refs['vs'].scrollIntoView('#d1', 500);
        },
        getPro(id){
          this.$nextTick(()=>{
            const url = `${getNewsUrl( this.$i18n.locale,id,100,1)}`
            this.$axios.get(url).then(res => {
              this.newsList=res.data.newsArr
              res.data.newsArr.map((item)=>{
                item.SHOWTIME=item.SHOWTIME.substr(0,10)
                item.month=item.SHOWTIME.substr(0,7)
                item.a=item.SHOWTIME.substr(8,10)
              })
            })
          })
        },
        gotoNews(id){
          this.$router.push({path:'/news',query:{id:id}})
        },
        handleScroll(vertical, horizontal, nativeEvent) {
          let top=vertical.scrollTop
          if(top>0){
            this.isShowNav=false
          }else{
            this.isShowNav=true
          }
        },
        showCon(n){
          this.select2=n
        },
      }
    }
</script>

<style lang="scss" scoped>
  .header{
    transition: 1s;
    &.active{
      transform: translateY(-100%);
    }
  }
.markCon{
  width:100%;
  .banner{
    width:100%;
    position: relative;
    .text{
      position: absolute;
      top:60%;
      left: 11%;
      color:white;
      span{
        font-size: 35px;
        font-weight: bold;
        display: inline-block;
        padding-bottom: 10px;
        position: relative;
        border-bottom: 1px solid rgba(255,255,255,.3);
      }
    }
    .threeBtn{
      width:100%;
      color:white;
      position: absolute;
      bottom: 0;
      display: flex;
      flex-direction: row;
      justify-content: center;
      span{
        display: inline-block;
        width:20%;
        color:#0C3665;
        padding:15px 10px;
        text-align: center;
        margin-left: 0.1%;
        font-weight: bold;
        cursor: pointer;
        background: linear-gradient(top, #0C3665,#0C3665) no-repeat;
        background-size: 100% 0%;
        text-transform: uppercase;
        -webkit-transition: all .5s;
        transition: all .5s;
        background-color:rgba(255,255,255,0.9);
      }
      span:hover{
        background-size: 100% 100%;
        color:white;
      }
    }
  }
  .rd{
    width:100%;
    padding-bottom: 60px;
    .title{
      width:100%;
      text-align: center;
      padding-bottom: 60px;
      padding-top: 60px;
      p{
        font-size: 25px;
        font-weight: bold;
        color:#0C3665;
        margin-block-start: 0em;
      }
      .three{
        width:20%;
        height:1px;
        margin: 0 auto;
        position: relative;
        span{
          width:40%;
          display: inline-block;
          height:100%;
          background-color: #ECECEC;
          position: absolute;
        }
        img{
          position: absolute;
          left: 45%;
          top:-10px;
        }
      }
    }
    .content{
      font-family: light;
      width:1280px;
      margin: 30px auto;
      line-height: 30px;
    }
    .conT{
      margin-top: 60px;
    }
    .mapB{
      display: none;
    }
  }
  .eq{
    width:100%;
    .title{
      width:100%;
      text-align: center;
      padding-bottom: 60px;
      padding-top: 60px;
      p{
        font-size: 25px;
        font-weight: bold;
        color:#0C3665;
        margin-block-start: 0em;
      }
      .three{
        width:20%;
        height:1px;
        margin: 0 auto;
        position: relative;
        span{
          width:40%;
          display: inline-block;
          height:100%;
          background-color: #ECECEC;
          position: absolute;
        }
        img{
          position: absolute;
          left: 45%;
          top:-10px;
        }
      }
    }
    .item{
      width:1280px;
      margin: 20px auto;
      background-color: #FAFAFA;
      display: flex;
      flex-direction: row;
      font-family: light;
      padding-top: 30px;
      padding-left: 2%;
      padding-bottom: 30px;
      span{
        display: inline-block;
        height:80px;
        width:80px;
        border-radius: 50%;
        position: relative;
        margin-top: 5px;
        background: linear-gradient(top,#0D80CA,#0D80CA) no-repeat;
        background-size: 100% 0%;
        text-transform: uppercase;
        -webkit-transition: all .5s;
        transition: all .5s;
        background-color: #D6D6D6;
        cursor: pointer;
        img{
          position: absolute;
          left:23%;
          top:20%;
        }
      }
      span:hover{
        background-size: 100% 100%;
      }
      p{
        width:82%;
        margin-left: 5%;
        text-align: left;
        font-size: 16px;
        line-height: 30px;
      }
    }
    .itemOne{
      margin-top: 60px;
      span{
        margin-top: 20px;
      }
    }
  }
  .qu{
    width:100%;
    .title{
      width:100%;
      text-align: center;
      padding-bottom: 60px;
      padding-top: 60px;
      p{
        font-size: 25px;
        font-weight: bold;
        color:#0C3665;
        margin-block-start: 0em;
      }
      .three{
        width:20%;
        height:1px;
        margin: 0 auto;
        position: relative;
        span{
          width:40%;
          display: inline-block;
          height:100%;
          background-color: #ECECEC;
          position: absolute;
        }
        img{
          position: absolute;
          left: 45%;
          top:-10px;
        }
      }
    }
    .a{
      width:1280px;
      margin: 0 auto;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding-bottom: 80px;
      .item{
        width:48%;
        display: flex;
        flex-direction: row;
        margin-top: 60px;
      cursor: pointer;
        .left{
          width:15%;
          display: flex;
          flex-direction: column;
          justify-content: center;

          span{
         display: inline-block;
         width:100%;
         text-align: center;
       }
          span:first-child{
            font-size: 40px;
            transition:color 2s;
            -webkit-transition:color 2s ;
          }
          span:last-child{
            font-family: light;
            font-size: 14px;
            color:#A2A2A2;
            transition:color 2s;
            -webkit-transition:color 2s ;
          }
        }
        .hr{
          display: inline-block;
          height:100%;
          width:1px;
          background-color: #C8C8C8;
          margin-left: 2%;
        }
        .right{
          width:80%;
          display: flex;
          flex-direction: column;
          margin-left: 4%;
          line-height: 30px;
          span:first-child{
            font-size: 22px;
            transition:color 2s;
            -webkit-transition:color 2s ;
          }
          span:first-child:hover{
            color:#C7000C;
          }
          span:last-child{
            font-family: light;
            font-size: 14px;
            color:#A2A2A2;
            transition:color 2s;
            -webkit-transition:color 2s ;
          }
          span:last-child:hover{
            color:black;
          }
        }
      }
      .item:hover .left span:first-child{
        color:#C7000C;
      }
      .item:hover .left span:last-child{
        color:black;
      }
      .item:hover .right span:first-child{
        color:#C7000C;
      }
      .item:hover .right span:last-child{
        color:black;
      }
    }
  }
  @media screen and (max-width: 1280px){
    .rd{
      .content{
        width:80%;
      }
    }
  }
  @media screen and (max-width:768px){
    .banner{
      img{
        height:500px !important;
        object-fit: cover;
      }
    }
    .eq{
      .item{
        width:100%;
      }
    }
    .qu{
      .a{
        width:96%;
        padding-left: 2%;
      }
    }
  }
  @media screen and (max-width:450px){
    .banner{
      .threeBtn{
        flex-direction: column;
        position: static;
        padding-bottom: 30px;
        span{
          width:100%;
          font-size: 10px;
          padding: 10px 5px;
          margin-top: 10px;
          background-color:#FAFAFA;
        }
      }
      .text{
        top:50%;
      }
    }
    .rd{
      .content{
        width:90%;
        margin-left: 5%;
        font-size: 14px;
      }
      .mapA{
        display: none;
      }
      .mapB{
        display: block;
        object-fit: cover;
        width:100%;
        height:100%;
      }
    }
    .eq{
      .itemOne{
        flex-direction: column;
        justify-content: center;
        position: relative;
        span{
       position: absolute;
          top:0;
          left:40%;
        }
        p{
          margin-top: 80px;
          width:90%;
          margin-left: 5%;
          font-size: 14px;
        }
      }
    }
    .qu{
      .title{
        padding-bottom: 30px;
      }
      .a{
        flex-direction: column;
        padding-bottom: 0;
        .item{
          width:100%;
          margin-left: 0 !important;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mark.vue